<template>
    <div id="galleriResult">
        <h2>{{ numberOfHits }}</h2>
        <div
            v-if="totalMatching > take"
            class="visually-hidden total"
            aria-live="polite"
            tabindex="-1"
        >
            {{ totalMatchingText }}
        </div>
        <div v-if="result && result.length > 0" class="row">
            <GalleriResultItem 
                v-for="(item, index) in result" 
                :key="index" 
                :resultItem="item" 
            >
            </GalleriResultItem>
        </div>
    </div>
</template>

<script>
import GalleriResultItem from "./galleriResultItem.vue";

export default {
    name: "GalleriResult",
    props: {
        result: Object,
        totalMatching: Number,
        totalMatchingText: String,
        take: Number
    },
    components: {
        GalleriResultItem
    },
    computed: {
        numberOfHits() {
            let single = _.isEqual(this.totalMatching, 1);
            return _.isEqual(this.$lang, "sv") 
                ? `Resultat: ${this.totalMatching} ${single ? "träff" : "träffar"}` 
                : `Result: ${this.totalMatching} ${single ? "hit" : "hits"}`;
        }
    }
}
</script>
